import { useEffect } from "react";
import { useState, createContext } from "react";

export const ShopContext = createContext(null);

const ShopContextProvider = (props) => {
    const databaseUrl = process.env.REACT_APP_DATABASE_URL;
    const [all_advertisement, setAll_Advertisement] = useState([]);
    const [currentId, setCurrentId] = useState(null);
    const [cartItems, setCartItems] = useState(() => {
        const savedCart = localStorage.getItem('cartItems');
        return savedCart ? JSON.parse(savedCart) : [];
    });
    const [selectedItems, setSelectedItems] = useState([]);
    
    useEffect(() => {
        localStorage.setItem('cartItems', JSON.stringify(cartItems));
    }, [cartItems]);

    const addToCart = (productId, quantity) => {
        setCartItems((prevItems) => {
            const existingProduct = prevItems.find(item => item.product_id === productId);

            if (existingProduct) {
                return prevItems.map(item => 
                    item.product_id === productId 
                    ? { ...item, quantity: item.quantity + quantity } 
                    : item
                );
            } else {
                return [...prevItems, { product_id: productId, quantity: quantity }];
            }
        });
    };

    const removeFromCart = (productId) => {
        setCartItems((prevItems) =>
            prevItems.filter(item => item.product_id !== productId)
        );
    };

    const updateCartQuantity = (productId, newQuantity) => {
        setCartItems((prevItems) =>
            prevItems.map(item => 
                item.product_id === productId 
                ? { ...item, quantity: newQuantity } 
                : item
            )
        );
    };

    const updateItemQuantity = (productId, quantity) => {
        setCartItems((prevItems) =>
            prevItems.map(item =>
                item.product_id === productId ? { ...item, quantity: quantity } : item
            )
        );

        setSelectedItems((prevSelected) =>
            prevSelected.map(item =>
                item.product_id === productId ? { ...item, quantity: quantity } : item
            )
        );
    };

    const selectForCheckout = (selectedProductIds) => {
        const selected = cartItems.filter(item => selectedProductIds.includes(item.product_id));
        setSelectedItems(selected); // Set only the selected products for checkout
    };

    const clearCartAfterCheckout = () => {
        setCartItems([]); // Empty the cart after checkout
    };

    // New function to remove selected items from the cart
    const removeSelectedItemsFromCart = () => {
        setCartItems((prevItems) => {
            return prevItems.filter(item => 
                !selectedItems.some(selectedItem => selectedItem.product_id === item.product_id)
            );
        });
        setSelectedItems([]);
    };

    useEffect(() => {
        fetch(`${databaseUrl}/alladvertisements`)
            .then((response) => response.json())
            .then((data) => setAll_Advertisement(data));
    }, []);

    // useEffect(() => {
    //     const fetchProducts = async () => {
    //         try {
    //             const response = await fetch(`${databaseUrl}/allproducts?limit=10&page=${page}`);
    //             if (!response.ok) throw new Error("Failed to fetch products");
        
    //             const data = await response.json();
        
    //             setAll_Product((prev) => [...prev, ...data.products]); // Append new products to the existing list
        
    //             // Update `hasMore` based on the total number of products and the number fetched so far
    //             if (all_product.length + data.products.length >= data.total) {
    //                 setHasMoreHome(false);
    //             }
        
    //             console.log(`Fetched products for page ${page}`);
    //         } catch (error) {
    //             console.error("Error fetching products:", error);
    //         }
    //     };

    //     fetchProducts();
    // }, [page])
    
      // Handle Load More

    const getTotalCartItems = () => {
        return cartItems.reduce((totalItems, item) => {
            return totalItems + item.quantity;
        }, 0);
    };

    const getProductId = (id) => {
        setCurrentId(id);
        setSelectedItems((prevSelected) => {
            if (prevSelected.some(item => item.product_id === id)) {
              return prevSelected.filter(item => item.product_id !== id);
            } else {
              const productToSelect = cartItems.find(item => item.product_id === id);
              return [...prevSelected, productToSelect];
            }
        });
    };

    // const [search, setSearch] = useState(null);
    // const getSearchItem = (search) => {
    //     setSearch(search);
    // }

    const contextValue = {
        selectedItems,
        currentId,
        getProductId,
        updateCartQuantity,
        clearCartAfterCheckout,
        selectForCheckout,
        removeSelectedItemsFromCart, 
        cartItems,
        addToCart,
        removeFromCart,
        all_advertisement,
        getTotalCartItems,
        setSelectedItems,
        updateItemQuantity,
    };

    return (
        <ShopContext.Provider value={contextValue}>
            {props.children}
        </ShopContext.Provider>
    );
}

export default ShopContextProvider;
